/* Kiyoh */

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('[data-kiyoh-block]').length > 0) {
    const fullStarSvg  = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"></path></svg>';
    const halfStarSvg  = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M528.5 171.5l-146.4-21.29l-65.43-132.4c-5.873-11.83-17.31-17.81-28.78-17.81c-11.39 0-22.82 5.89-28.7 17.8l-65.43 132.4L47.47 171.5C21.2 175.3 10.68 207.6 29.72 226.1l105.9 102.1l-25.04 145.5C107 495.3 123.6 512 142.2 512c4.932 0 10.01-1.172 14.88-3.75L288 439.6l130.9 68.7c4.865 2.553 9.926 3.713 14.85 3.713c18.61 0 35.21-16.61 31.65-37.41l-25.05-145.5l105.9-102.1C565.3 207.6 554.8 175.3 528.5 171.5zM406.9 294.7L388.8 312.3l23.83 138.4L288 385.4V68l62.31 126.1l139.2 20.25L406.9 294.7z"></path></svg>';
    const emptyStarSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M528.5 171.5l-146.4-21.29l-65.43-132.4C310.9 5.971 299.4-.002 287.1 0C276.6 0 265.1 5.899 259.3 17.8L193.8 150.2L47.47 171.5C21.2 175.3 10.68 207.6 29.72 226.1l105.9 102.1L110.6 474.6C107 495.3 123.6 512 142.2 512c4.932 0 10.01-1.172 14.88-3.75L288 439.6l130.9 68.7c4.865 2.553 9.926 3.713 14.85 3.713c18.61 0 35.21-16.61 31.65-37.41l-25.05-145.5l105.9-102.1C565.3 207.6 554.8 175.3 528.5 171.5zM390.2 320.6l22.4 130.1l-117.2-61.48c-4.655-2.442-10.21-2.442-14.87 .0001L163.4 450.7l22.4-130.1C186.7 315.4 184.1 310.1 181.2 306.4l-94.7-92.09l130.9-19.04C222.6 194.5 227.1 191.2 229.4 186.5L288 67.99l58.59 118.5c2.331 4.717 6.833 7.986 12.04 8.744l130.9 19.04l-94.7 92.09C391 310.1 389.3 315.4 390.2 320.6z"></path></svg>';
    
    fetch('https://www.kiyoh.com/widget/1075873/mail_female').then(function(data) {
      data.text().then(function(page) {
        const tmpPage = document.createElement('html');
        tmpPage.innerHTML = page;
  
        const rating = tmpPage.querySelector('.rating').innerText;
        const reviews = tmpPage.querySelector('.review-count span').innerHTML;
        const fullStarsAmount = tmpPage.querySelectorAll('.icon-star').length;
        const halfStarExists = tmpPage.querySelectorAll('.icon-star-half-full').length > 0;
  
        const ratingContainers = document.querySelectorAll('[data-kiyoh-rating]');
        for (const elem of ratingContainers) {
          elem.innerText = rating;
        }
  
        const reviewersContainers = document.querySelectorAll('[data-kiyoh-review-count]');
        for (const elem of reviewersContainers) {
          elem.innerHTML = reviews;
        }
  
        const starsContainers = document.querySelectorAll('[data-kiyoh-stars]');  
        for (const elem of starsContainers) {
          let halfStarAlreadyAdded = false;
          
          for (let i = 0; i < 5; i++) {
            if (i < fullStarsAmount) {
              elem.innerHTML += '<span class="kiyoh-star-full">' + fullStarSvg + '</span>';
            } else {
              if (halfStarExists && !halfStarAlreadyAdded) {
                elem.innerHTML += '<span class="kiyoh-star-half-full">' + halfStarSvg + '</span>';
                halfStarAlreadyAdded = true;
              } else {
                elem.innerHTML += '<span class="kiyoh-star-empty">' + emptyStarSvg + '</span>';
              }
            }
          }
        }
        
        const widgetContainers = document.querySelectorAll('[data-kiyoh-block] > *'); 
        for (const elem of widgetContainers) {
          if (typeof elem.dataset.kiyohLoading === 'undefined') {
            elem.removeAttribute('hidden');
          } else {
            elem.setAttribute('hidden', '');
          }
        }
      }); 
    });
  }
});


window.addEventListener('DOMContentLoaded', () => {
  document.querySelector('variant-selection')?.addEventListener('variant-change', ({ detail }) => {
    const upsellMainVariantImages = document.querySelectorAll('div[upsell-main-variant-image]');
    const upsellMainProductPriceElement = document.querySelector('.product-upsell span[main-product-price]');
    const productUpsellItem = document.querySelector('product-upsell-item');
    
    upsellMainVariantImages.forEach(el => {
      const variantId = Number(el.getAttribute('upsell-main-variant-image'));

      if (detail?.variant.id) {
        if (detail?.variant.id === variantId) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      }
    })

    if (upsellMainProductPriceElement && detail?.variant.price) {
      upsellMainProductPriceElement.setAttribute('main-product-price', detail?.variant.price);
    }

    if (productUpsellItem) {
      productUpsellItem.updateTotalPrice();
    }
  })

  /* --- Product Upsell Elemenent--- */

  var ProductUpsellItem = class extends HTMLElement {
    constructor() {
      super();
      this.upsellSelector = this.querySelector('[name="upsell-product"]');
      // this.variantSelector = this.querySelector('.product-upsell-select');
      this.upsellPrices = this.querySelector('.product-upsell-prices');
      this.upsellItemIdInput = this.querySelector('input[upsell-item-id]');
      this.upsellItemIdQuantity = this.querySelector('input[upsell-item-quantity]');

      this.productId = this.dataset.productId;
      this.moneyFormat = this.dataset.moneyFormat;
      this.discountPerItem = this.dataset.discountPerItem;
      this.productImageElement = this.productId ? document.querySelector(`[upsell-image-id="${this.productId}"]`) : null;

      if (
        this.upsellSelector &&
        // this.variantSelector &&
        this.upsellItemIdInput &&
        this.upsellItemIdQuantity) {
        this.init();
      }
    }

    init() {
      this.upsellSelector.addEventListener('change', event => {
        if (event.target.checked) {
          this.upsellItemIdInput.removeAttribute('disabled');
          this.upsellItemIdQuantity.removeAttribute('disabled');
          this.showPoductImage();
          this.updateTotalPrice();
        } else {
          this.upsellItemIdInput.setAttribute('disabled', '');
          this.upsellItemIdQuantity.setAttribute('disabled', '');
          this.hidePoductImage();
          this.updateTotalPrice();
        }
      })

      // this.variantSelector.addEventListener('change', event => {
      //   const selectedVariantId = event.target.value;
      //   this.updateVariantPrice(selectedVariantId);
      //   this.updateTotalPrice();
      // })
    }

    showPoductImage() {
      if (this.productImageElement) {
        this.productImageElement.removeAttribute('hidden');
      }
    }

    hidePoductImage() {
      if (this.productImageElement) {
        this.productImageElement.setAttribute('hidden', '');
      }
    }

    updateVariantPrice(variantId) {
      const pricesElements = this.upsellPrices.querySelectorAll('.product-upsell-price');
      this.upsellItemIdInput.value = variantId;
      
      pricesElements.forEach(el => {
        const priceVariantId = el.getAttribute('variant-id');

        if (priceVariantId == variantId) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      })
    }

    updateTotalPrice() {
      const productUpsellItems = this.parentNode.querySelectorAll('product-upsell-item');
      const productUpsellTotalPriceWrapper = this.parentNode.parentNode.querySelector('.product-upsell-total-price-wrapper');
      const currentProductPrice = this.parentNode.parentNode.querySelector('span[product-upsell-total-price]');
      const currentCompareProductPrice = this.parentNode.parentNode.querySelector('span[product-upsell-compare-total-price]');
      let upsellTotalPrice = 0;

      productUpsellItems.forEach(el => {
        const upsellSelector = el.querySelector('[name="upsell-product"]');
        
        if (upsellSelector.checked === true) {
          // const productUpsellSelectValue = el.querySelector('.product-upsell-select').value;

          // if (productUpsellSelectValue) {
          //   upsellTotalPrice += Number(el.querySelector(`.product-upsell-prices div[variant-id="${productUpsellSelectValue}"]`).getAttribute('variant-price'));
          // }

          upsellTotalPrice += Number(el.querySelector(`.product-upsell-prices div[variant-id]`).getAttribute('variant-price'));
        }
      })

      if (currentProductPrice) {
        const mainProductPrice = Number(currentProductPrice.getAttribute('main-product-price'));
        //const selectedUpsellProductsCount = document.querySelectorAll('product-upsell-item input:checked[name="upsell-product"]').length;
        const totalDiscount = Number(this.discountPerItem);
        let discountPrice = null;

        if (window.Shopify.formatMoney) {
          
          if (totalDiscount > 0) {
            discountPrice = mainProductPrice + Math.round(upsellTotalPrice * ((100 - totalDiscount) / 100));
            console.log('discountPrice => ', discountPrice)
            console.log('mainProductPrice => ', mainProductPrice)
            currentProductPrice.innerHTML = window.Shopify.formatMoney(discountPrice, this.moneyFormat);
            if (mainProductPrice < discountPrice) {
              currentCompareProductPrice.innerHTML = window.Shopify.formatMoney(mainProductPrice + upsellTotalPrice, this.moneyFormat);
              productUpsellTotalPriceWrapper.removeAttribute('hidden');
            } else {
              currentCompareProductPrice.innerHTML = '';
              productUpsellTotalPriceWrapper.setAttribute('hidden', true);
            }

          } else {
            currentProductPrice.innerHTML = window.Shopify.formatMoney(upsellTotalPrice, this.moneyFormat);
          }
        }
      }
    }
  }
  
  window.customElements.define('product-upsell-item', ProductUpsellItem);
})